module.exports = __webpack_public_path__ + "img/login-desc.513af4cc.png";